import { render, staticRenderFns } from "./DesignTemplateCard.vue?vue&type=template&id=40963422"
import script from "./DesignTemplateCard.vue?vue&type=script&lang=js"
export * from "./DesignTemplateCard.vue?vue&type=script&lang=js"
import style0 from "./DesignTemplateCard.vue?vue&type=style&index=0&id=40963422&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports